export const EN = {
    downgrade_cracked_screen: {
        translation: "Cracked Screen",
    },
    downgrade_cosmetics: {
        translation: "Cosmetics",
    },
    downgrade_lcd_issues: {
        translation: "LCD issues",
    },
    downgrade_functionality: {
        translation: "Functionality",
    },
    downgrade_battery: {
        translation: "Battery",
    },
    downgrade_no_power: {
        translation: "No power",
    },
    downgrade_account_lock: {
        translation: "Account lock",
    },
    downgrade_changed_product: {
        translation: "Changed Product",
    },
    title_trade_in_summary: {
        translation: "Trade-in Summary",
    },
    title_item: {
        translation: "Item",
    },
    title_value: {
        translation: "Order Reference",
    },
    title_reference: {
        translation: "Reference",
    },
    title_original_value: {
        translation: "Original Value",
    },
    title_inspected_value: {
        translation: "Inspected Value",
    },
    title_status: {
        translation: "Status",
    },
    title_created_at: {
        translation: "Date Created",
    },
    title_expires_at: {
        translation: "Date Expires",
    },
    title_decision_made_at: {
        translation: "Decision Made At",
    },
    title_item_breakdown: {
        translation: "Item Breakdown",
    },
    title_item_reference: {
        translation: "Item Reference",
    },
    title_item_name: {
        translation: "Item Name",
    },
    title_downgrade_reason: {
        translation: "Downgrade Reason",
    },
    title_quoted_grade: {
        translation: "Quoted Grade",
    },
    title_current_grade: {
        translation: "Current Grade",
    },
    title_quoted_value: {
        translation: "Quoted Value",
    },
    title_current_value: {
        translation: "Current Value",
    },
    title_accept_reject_offer: {
        translation: "Please accept or reject the assessed offer",
    },
    text_accept_reject: {
        translation: "Please note that the offer is only valid for 14 days. If no response is recorded, the offer will be automatically rejected and your device will be sent back to you. ",
    },
    text_decision_made: {
        translation: "The decision has already been made on this item",
    },
    button_accept: {
        translation: "Accept",
    },
    button_reject: {
        translation: "Reject",
    },
    error_404: {
        translation: "Could not find the order"
    },
    error_500: {
        translation: "Something has gone wrong fetching the order"
    },
    month_1: {
        translation: "January",
    },
    month_2: {
        translation: "February",
    },
    month_3: {
        translation: "March",
    },
    month_4: {
        translation: "April",
    },
    month_5: {
        translation: "May",
    },
    month_6: {
        translation: "June",
    },
    month_7: {
        translation: "July",
    },
    month_8: {
        translation: "August",
    },
    month_9: {
        translation: "September",
    },
    month_10: {
        translation: "October",
    },
    month_11: {
        translation: "November",
    },
    month_12: {
        translation: "December",
    }
};

export const FR = {
    downgrade_cracked_screen: {
        translation: "Écran fissuré"
    },
    downgrade_cosmetics: {
        translation: "Cosmétiques"
    },
    downgrade_lcd_issues: {
        translation: "Problèmes d'écran LCD"
    },
    downgrade_functionality: {
        translation: "Fonctionnalité"
    },
    downgrade_battery: {
        translation: "Batterie"
    },
    downgrade_no_power: {
        translation: "Pas de puissance"
    },
    downgrade_account_lock: {
        translation: "Verrouillage de compte"
    },
    downgrade_changed_product: {
        translation: "Produit modifié"
    },
    title_trade_in_summary: {
        translation: "Résumé de l’échange"
    },
    title_item: {
        translation: "L'objet"
    },
    title_value: {
        translation: "Référence de l'achat"
    },
    title_reference: {
        translation: "Référence"
    },
    title_original_value: {
        translation: "Valeur d’origine"
    },
    title_inspected_value: {
        translation: "Valeur inspectée"
    },
    title_status: {
        translation: "Statut"
    },
    title_created_at: {
        translation: "Date créée"
    },
    title_expires_at: {
        translation: "Date d'expiration",
    },
    title_decision_made_at: {
        translation: "Décision prise à"
    },
    title_item_breakdown: {
        translation: "Détails de la commande"
    },
    title_item_reference: {
        translation: "Référence l'objet"
    },
    title_item_name: {
        translation: "Description l'objet"
    },
    title_downgrade_reason: {
        translation: "Raison de déclassement"
    },
    title_quoted_grade: {
        translation: "Classe citée"
    },
    title_current_grade: {
        translation: "Classe actuelle"
    },
    title_quoted_value: {
        translation: "Valeur citée"
    },
    title_current_value: {
        translation: "Valeur actuelle"
    },
    title_accept_reject_offer: {
        translation: "Veuillez accepter ou refuser l'offre évaluée"
    },
    text_accept_reject: {
        translation: "Veuillez noter que l'offre n'est valable que 14 jours. Si aucune réponse n'est enregistrée, l'offre sera automatiquement rejetée et votre appareil vous sera renvoyé"
    },
    text_decision_made: {
        translation: "La décision a déjà été prise sur ce point",
    },
    button_accept: {
        translation: "Accepter"
    },
    button_reject: {
        translation: "Rejeter"
    },
    error_404: {
        translation: "Quelque chose s’est mal passé pour aller chercher l’ordre"
    },
    error_500: {
        translation: "N’a pas pu trouver l’ordre"
    },
    month_1: {
        translation: "Janvier",
    },
    month_2: {
        translation: "Février",
    },
    month_3: {
        translation: "Mars",
    },
    month_4: {
        translation: "Avril",
    },
    month_5: {
        translation: "Mai",
    },
    month_6: {
        translation: "Juin",
    },
    month_7: {
        translation: "Julliet",
    },
    month_8: {
        translation: "Août",
    },
    month_9: {
        translation: "Septembre",
    },
    month_10: {
        translation: "Octobre",
    },
    month_11: {
        translation: "Novembre",
    },
    month_12: {
        translation: "Décembre",
    }
};


// WEBPACK FOOTER //
// ./src/components/lang.js